import type { Theme } from '@mui/material';

export const LEGEND_SWATCH_RADIUS = '1px';

export const ZOOM_CONTROLS_MARGIN = ({ tokens: { space } }: Theme) =>
  `${space.md} ${space.mdMinus} -${space.lg} auto`;

export const RESULT_FEEDBACK_BUTTON_LABEL = 'Result Feedback';
export const REMOVE_CHANGEPOINT_BUTTON_LABEL = 'Remove changepoint';
